<template>
  <div class="KeypointsTitles" v-show="!store.state.user.isOnKeypoint || store.state.isEnded">
    <div class="KeypointsTitle" ref="r11">
      {{$t('keypointsTitles.r11')}}
    </div>
    <div class="KeypointsTitle" ref="r12">
      {{$t('keypointsTitles.r12')}}
    </div>
    <div class="KeypointsTitle" ref="r13">
      {{$t('keypointsTitles.r13')}}
    </div>
    <div class="KeypointsTitle" ref="r21">
      {{$t('keypointsTitles.r21')}}
    </div>
    <div class="KeypointsTitle" ref="r22">
      {{$t('keypointsTitles.r22')}}
    </div>
  </div>
</template>

<script>
import emitter from '@/emitter'

export default {
  data() {
    return {
      current: null
    }
  },
  inject: ['store'],
  mounted () {
    window.addEventListener('mousemove', this.onMouseMove)
    emitter.on('KP:HOVER:ON', this.onHover)
    emitter.on('KP:HOVER:OFF', this.offHover)
  },
  beforeUnmount() {
    window.removeEventListener('mousemove', this.onMouseMove)
    emitter.off('KP:HOVER:ON', this.onHover)
    emitter.off('KP:HOVER:OFF', this.offHover)
  },
  methods: {
    onMouseMove(e) {
      if (this.current === null) return
      let left = e.offsetX
      let top = e.offsetY
      this.current.style.left = left + 60 + 'px'
      this.current.style.top = top - 30 + 'px'
    },
    onHover(id) {
      if (this.current === this.$refs[id]) return
      this.$refs[id].style.display = 'block'
      this.current = this.$refs[id]

    },
    offHover() {
      if (!this.current) return
      this.current.style.display = 'none'
      this.current = null
    }
  }
}
</script>

<style lang="stylus" scoped>
.KeypointsTitles
  .KeypointsTitle
    position absolute
    z-index 0
    top 0
    left 0
    display none
    text-transform uppercase
    font-size 18px
    letter-spacing 2px
    width 240px
    border-left 1px solid white
    padding-left 10px
</style>